import { render, staticRenderFns } from "./package_icon_and_name.vue?vue&type=template&id=8564d9c6&"
import script from "./package_icon_and_name.vue?vue&type=script&lang=js&"
export * from "./package_icon_and_name.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports